<template>
  <div class="full-page-wrap">
    <div style="display: none">
      <img
        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1647457916091E1647459328886%2FDTU_WYSD_Banner.jpg?alt=media"
      />
      <img
        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1647457916091E1647459328886%2FUPNVY-Event-Banner-Upcoming-Events.jpg?alt=media"
      />
      <img
        src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FEvent%20Banner-CDTI-min.jpg?alt=media"
      />
      <img
        src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2FpartnerBanner.jpg?alt=media"
      />
      <img
        src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FSkillsFuture%20Festival-min.png?alt=media"
      />
      <img
        src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FWorld%20X-min.png?alt=media"
      />

      <img
        src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2Fideathon_challenge.jpg?alt=media"
      />
    </div>
    <div class="container">
      <div class="inner-page-wrap mt-5">
        <h3 class="common-head text-center my-8 ">
          Closing Video For the World Youth Skills Day (Asia Pacific) 2022.<br/>Thank you for your support.
        </h3>
        <!-- <carousel :autoplay="true" :loop="true" :items="1" :dots="false">
          <img src="../assets/Images/landing/slider.jpg" />

          <img src="../assets/Images/landing/slider.jpg" />
        </carousel> -->
        <div class="video-banner position-relative">
          <img src="../assets/Images/landing/banner_closing.jpg" />
          <div class="new-play-btn">
            <label
              for="topBannerFile "
              @click="OpenBannerVideo()"
              class="circle_blink_button"
            >
              <v-icon color="#fff" size="60px">mdi-play</v-icon>
            </label>
          </div>
        </div>

        <div v-show="showCountdown" class="event-coundown-timer mt-5">
          <Countdown
            v-if="eventDetail && CounterEventStartDate"
            :deadline="CounterEventStartDate"
          ></Countdown>
        </div>
        <div class="count-me mt-12">
          <a href="javascript:void(0);" @click="clickOpenOption()">Register</a>
        </div>

        <h3 class="common-head text-center mt-12">
          World Youth Skills Day (Asia - Pacific) 2022
        </h3>
        <div class="about-desc">
          <div class="about-logo">
            <img src="../assets/Images/landing/wysd-logo.png" />
          </div>
          <div class="about-text">
            <p>
              Designated by the United Nations General Assembly in 2014, the
              World Youth Skills Day (WYSD) is an opportunity for young people,
              technical and vocational education and training (TVET)
              institutions and public and private sector stakeholders to
              acknowledge and celebrate the importance of equipping young people
              with skills for employment, decent work and entrepreneurship.
              Since 2014, WYSD is celebrated every year on 15 July in which
              UNESCO-UNEVOC is one of the key actors in promoting WYSD at the
              global level.
            </p>
            <br />
            <p>
              Organised by Temasek Polytechnic (TP), together with UNEVOC
              Centres, local and regional partners, the
              <strong>WYSD (Asia-Pacific) 2022 initiative</strong> will bring
              out the voice of youths so that various stakeholders in TVET can
              better understand the attitudes of youths when it comes to skills
              needed for the future.
            </p>
            <br />
            <p>
              Themed “YOUth Matters: Celebrating Skills for the Future”, the
              inaugural WYSD (APAC) initiative will be uniquely celebrated from
              <strong>7 July to 31 October 2022</strong>, featuring several
              events and activities organised by TP and partners from the
              region.
            </p>
          </div>
        </div>

        <div class="upcoming session-video-wrap pb-5">
          <!-- <h3 class="common-head text-center">Upcoming Event Videos</h3> -->
          <div class="video-wrap-inner mt-10">
            <carousel
              :autoplay="false"
              :loop="true"
              :items="5"
              :dots="false"
              :margin="30"
              :nav="false"
              :responsive="{
                0: { items: 1, nav: true },
                768: { items: 2, nav: true },
                1025: { items: 2, nav: true },
                1200: { items: 3, nav: true },
              }"
            >
              <div
                v-for="upcomingSessionVideo in SessionVideo"
                :key="upcomingSessionVideo.sessionVideoId"
                class="upcoming-session-video position-relative"
              >
                <img :src="upcomingSessionVideo.SessionVideoThumb" />
                <div
                  @click="openSessionVideo(upcomingSessionVideo)"
                  class="play-btn"
                >
                  <img src="../assets/Images/landing/play.svg" />
                </div>
              </div>
            </carousel>
          </div>
        </div>
      </div>
    </div>

    <div class="container pt-8">
      <div class="session-stepper-wrap">
        <v-tabs
          show-arrows
          grow
          background-color="transparent"
          color="#333"
          v-model="selectedEventTab"
        >
          <!-- <v-tabs-slider color="#333"></v-tabs-slider> -->
          <!-- <v-tab class="mr-3" @click="LoadSessions('E1647445200290')"> Main Symposium &amp; Opening Ceremony </v-tab> -->
          <!-- <v-tab class="mr-3" @click="LoadSessions('E1639074934324')"> Jul'22 </v-tab> -->

          <!--             
              <v-tab class="mr-3" @click="LoadSessions()">
                Main Symposium &amp; Opening Ceremony
              </v-tab>
              <v-tab class="mr-3" @click="LoadSessions()"> Jul'22 </v-tab>
              <v-tab class="mr-3" @click="LoadSessions()"> Aug'22 </v-tab>
              <v-tab class="mr-3" @click="LoadSessions()"> Sept'22 </v-tab>
              <v-tab class="mr-3" @click="LoadSessions()"> Oct'22 </v-tab>
              <v-tab @click="LoadSessions()"> Closing Ceremony </v-tab> -->

          <v-tab
            v-for="eventItem of eventList"
            :key="eventItem.EventId"
            :id="eventItem.EventId"
            class="mx-2"
            @click="LoadSessions(eventItem.EventId)"
          >
            {{ eventItem.Name }}
          </v-tab>
          <!-- <v-tab>Youth Declaration Closing Ceremony</v-tab> -->
        </v-tabs>
      </div>
    </div>

    <div
      class="home-sessions-wrap mt-5"
      style="width: 100%; background: #ebeff2; padding: 0px 0 40px"
    >
      <div v-if="currentDomain && clientId && selectedEventId && selectedEventId != 'E1665657022153'" class="container">
        <div class="inner-page-wrap" style="position: relative; padding-top: 0px;">
          <div v-if="selectedEventId == defaultEventId" class="home-session-timezone">
            <h6 class="meeting-time-zone">{{ localTimeZone }}</h6>
          </div>
          <div
            v-show="sessionsLoading"
            class="text-center home-loader-section"
            style="position: absolute; z-index: 9; width: 100%"
          >
            <div class="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <iframe
            v-if="currentDomain && clientId && selectedEventId"
            id="divPublicSessions"
            style="width: 100%; min-height: 100px; border: 0"
            @load="SessionsLoaded"
            :src="
              currentDomain +
              '/widget/PublicSessions.html?env=' +
              environment +
              '&c=' +
              clientId +
              '&e=' +
              selectedEventId +
              '&o=' +
              tabOrientation +
              '&tab_hash_tag=' +
              tab_hash_tag +
              '&date_group=' +
              date_group +
              '&external_session_details_popup=' +
              external_session_details_popup +
              '&donot_show_details_popup=' +
              donot_show_details_popup +
              '&join_inperson_session_anytime=' +
              join_inperson_session_anytime +
              '&allow_guest_join_inperson_session=' +
              allow_guest_join_inperson_session +
              '&session_date_format=' +
              session_date_format +
              '&hide_speaker_enabled=' +
              hide_speaker_enabled +
              '&t=' +
              cts
            "
          />
        </div>
      </div>
      <!-- <div v-if="selectedEventId == 'E1665657022153'" class="container">
        <div class="inner-page-wrap mt-5">
          <div class="cloasing_banner position-relative">
            <img src="../assets/Images/landing/banner_closing.jpg" />
            <div class="closing-play-btn">
              <label for="topBannerFile " @click="OpenBannerVideo()">
                <v-icon color="#fff" size="60px">mdi-play</v-icon>
              </label>
            </div>
          </div>
        </div>
      </div> -->
      <div v-if="selectedEventId == 'E1665657022153'" class="youth-declaration mt-8 pt-6">
        <div class="container">
          <div
            class="py-8 px-5 py-md-12 youth-declaration"
            style="background-color: #fff; border-radius: 10px"
          >
            <h3 class="common-head">Youth Declaration</h3>
            <p>
              The Youth Declaration by the World Youth Skills Day (Asia Pacific)
              2022 Youth Ambassadors aims to capture and formalise the youth
              voices raised during the below four avenues, thereby allowing the
              youth voices in Asia-Pacific to be heard by the United Nations
              fraternity on youth and skills:
            </p>
            <ol type="a">
              <li>World Youth Skills Day (APAC) Main Symposium;</li>
              <li>WYSD (APAC) Youth Ambassador Programme Team Challenges;</li>
              <li>
                UNESCO-UNEVOC TVET Youth Voices Campaign in collaboration with
                UNESCO-UNEVOC;
              </li>
              <li>
                Ground-up initiatives organised by youths contributing to youth
                and skills;
              </li>
            </ol>
            <v-row>
              <v-col lg="4" md="4" cols="12">
                <div class="single-declaration">
                  <div class="declaration-image">
                    <img
                      src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2FScr_TP%20WYSD%20Topic%201.png?alt=media&token=f448b951-8508-42dd-b45e-21733e3f4cc8"
                    />
                  </div>
                  <p>
                    Key Topic 1: Development of Future-Ready Skills in the Green
                    &amp; Digital Economy
                  </p>
                </div>
              </v-col>
              <v-col lg="4" md="4" cols="12">
                <div class="single-declaration">
                  <div class="declaration-image">
                    <img
                      src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2FScr_TP%20WYSD%20Topic%202.png?alt=media&token=f295f367-06e1-4f9e-9a69-feed3563a3b8"
                    />
                  </div>
                  <p>Key Topic 2: Redesigning TVET for the Future.</p>
                </div>
              </v-col>
              <v-col lg="4" md="4" cols="12">
                <div class="single-declaration">
                  <div class="declaration-image">
                    <img
                      src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2FScr_TP%20WYSD%20Topic%203.png?alt=media&token=4b15b807-851e-49b8-929c-4c9a7623a641"
                    />
                  </div>
                  <p>Key Topic 3: Building Inclusive TVET Systems</p>
                </div>
              </v-col>
            </v-row>
            <div class="download-pdf count-me mt-8">
              <v-btn width="auto" @click="openNewPdf()"
                ><v-icon color="#ffffff" size="25px" class="mr-2"
                  >mdi-download</v-icon
                >
                Download Youth Declaration</v-btn
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="speaker-list-slide-sec py-8">
      <h3 class="common-head text-center">Speakers</h3>

      <embed
        v-if="currentDomain && clientId && defaultEventId"
        style="
          width: 100%;
          min-height: 450px;
          max-height: 450px;
          overflow: hidden;
          padding: 0 25px;
        "
        :src="
          currentDomain +
          '/widget/PublicSpeakers.html?env=' +
          environment +
          '&c=' +
          clientId +
          '&e=' +
          defaultEventId +
          '&carousel_mode=1' +
          '&t=' +
          cts
        "
      />
    </div>
    <div class="hear-from-youth py-16">
      <h3 class="common-head text-center">Lets Hear From Our Youths</h3>
      <div class="container">
        <div class="inner-page-wrap mt-5">
          <carousel
            :autoplay="false"
            :loop="true"
            :items="5"
            :dots="false"
            :margin="30"
            :nav="true"
            :responsive="{
              0: { items: 1, nav: true },
              768: { items: 3, nav: true },
              1025: { items: 4, nav: true },
              1200: { items: 5, nav: true },
            }"
          >
            <div
              v-for="videoThumb in YouthEvent"
              :key="videoThumb.videoId"
              class="single-youth-video"
            >
              <img :src="videoThumb.ThumbImg" />
              <div class="play-btn" @click="OpenYouthVideo(videoThumb)">
                <img src="../assets/Images/landing/play.svg" />
              </div>
            </div>
          </carousel>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="inner-page-wrap mt-5">
        <div class="organised-by py-8">
          <div class="single-organised">
            <h3>Organised by</h3>
            <div class="d-flex justify-content-center align-items-center">
              <div
                class="
                  organised-list
                  mt-12
                  d-flex
                  justify-content-center
                  align-items-center
                  flex-column flex-md-row
                "
              >
                <div class="mb-4 mb-md-0 mr-md-5 mr-0 single-foot-logo1">
                  <img src="../assets/Images/landing/temasek-logo.png" />
                </div>
                <div class="mb-4 mb-md-0 mr-md-5 mr-0 single-foot-logo3">
                  <img src="../assets/Images/landing/unesco.png" />
                </div>
              </div>
            </div>
          </div>
          <div class="single-organised">
            <h3>Key Partners</h3>
            <div
              class="
                organised-list
                mt-12
                left-right-border
                d-flex
                justify-content-center
                align-items-center
                flex-column flex-md-row
              "
            >
              <div class="mb-4 mb-md-0 mr-md-5 mr-0 single-foot-logo2">
                <img src="../assets/Images/landing/unesco-2.png" />
              </div>
              <div class="single-foot-logo">
                <img src="../assets/Images/landing/new-nyc-logo.png" />
              </div>
              <div class="mb-4 mb-md-0 mr-md-5 mr-0 single-foot-logo4">
                <img src="../assets/Images/landing/logo3.png" />
              </div>

              <div class="single-foot-logo4">
                <img src="../assets/Images/landing/logo4.png" />
              </div>
            </div>
          </div>
          <div class="single-organised">
            <h3>In support of</h3>
            <div class="organised-list mt-12">
              <div class="mb-4 single-foot-logo-3">
                <img src="../assets/Images/landing/Skill-future-new.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="newhome-footer">
      <PublicFooter></PublicFooter>
    </div>

    <v-dialog
      v-model="RegPageOptions"
      width="631px"
      content-class="reg-options-whole position-relative"
    >
      <v-card>
        <v-btn class="goto-option-close" icon @click="RegPageOptions = false"
          ><v-icon color="#333" size="25px">mdi-close</v-icon></v-btn
        >
        <v-card-text class="p-0">
          <RegOptions :key="key"></RegOptions>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loginDecision"
      width="560px"
      content-class="reg-options-whole position-relative"
    >
      <v-card>
        <v-btn class="goto-option-close" icon @click="loginDecision = false"
          ><v-icon color="#333" size="25px">mdi-close</v-icon></v-btn
        >
        <v-card-text class="p-0">
          <div class="join-session-option-text">
            <h3>Do you want to join the session?</h3>
            <div class="event-enter-butn mt-6 p-0 session-join-butns">
              <v-btn
                class="register-button"
                width="100%"
                @click="
                  loginDecision = false;
                  goToRegister(selectedSessionId);
                "
              >
                Register Now
              </v-btn>
              <p class="mt-4 mb-2">Already registered?</p>
              <v-btn
                class="custom-button mb-2 mb-sm-0 mb-xl-2 mb-md-2"
                @click="
                  loginDecision = false;
                  goToLogin(selectedSessionId);
                "
              >
                Login
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="hearYouth"
      width="850px"
      content-class="reg-options-whole position-relative"
      @click:outside="closeDialog"
    >
      <v-card height="600px">
        <v-btn class="goto-option-close" icon @click="closeDialog"
          ><v-icon color="#333" size="25px">mdi-close</v-icon></v-btn
        >
        <v-card-text class="p-0">
          <div class="youth-video-wrap">
            <iframe
              height="100%"
              width="100%"
              allow="autoplay"
              :src="videoUrl"
              allowfullscreen="true"
            ></iframe>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="BannerVideo"
      width="850px"
      content-class="reg-options-whole position-relative"
      @click:outside="closeBannerVideo"
    >
      <v-card height="600px">
        <v-btn class="goto-option-close" icon @click="closeBannerVideo"
          ><v-icon color="#333" size="25px">mdi-close</v-icon></v-btn
        >
        <v-card-text class="p-0">
          <div class="youth-video-wrap">
            <iframe
              height="100%"
              width="100%"
              allow="autoplay"
              :src="bannerVideoUrl"
              allowfullscreen="true"
            ></iframe>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="SessionVideoDialog"
      width="850px"
      content-class="reg-options-whole position-relative"
      @click:outside="closeSessionVideoDialog"
    >
      <v-card height="600px">
        <v-btn class="goto-option-close" icon @click="closeSessionVideoDialog"
          ><v-icon color="#333" size="25px">mdi-close</v-icon></v-btn
        >
        <v-card-text class="p-0">
          <div class="youth-video-wrap">
            <iframe
              height="100%"
              width="100%"
              allow="autoplay"
              :src="sessionVideoUrl"
              allowfullscreen="true"
            ></iframe>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="sessionDetailsPopup"
      width="1000px"
      content-class="reg-options-whole position-relative"
    >
      <v-card>
        <v-btn
          class="goto-option-close"
          icon
          @click="sessionDetailsPopup = false"
          ><v-icon color="#333" size="25px">mdi-close</v-icon></v-btn
        >
        <v-card-text class="p-0">
          <SessionDetails
            :key="sessionDetailsKey"
            :sn="currentSession"
            :hide_speaker_enabled="hide_speaker_enabled"
            :isPublicPage="isPublicPage"
            @goToSession="goToSession"
          ></SessionDetails>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<style>
/* .home-sessions-wrap embed {
  scrollbar-color: #888 #333;
  scrollbar-width: thin;
}
.home-sessions-wrap embed ::-webkit-scrollbar {
  width: 6px;
}

.home-sessions-wrap embed ::-webkit-scrollbar-track {
  background: #333;
}

.home-sessions-wrap embed ::-webkit-scrollbar-thumb {
  background: #888;
}
.home-sessions-wrap embed ::-webkit-scrollbar-thumb:hover {
  background: #555;
} */
.newhome-footer .footer-bottom-section {
  margin-top: 0 !important;
}
</style>
<script>
import jQuery from "jquery";
let $ = jQuery;
import { bus } from "@/main";
import APIs from "@/components/APIInit";
import db from "../components/firebaseInit";
import axios from "axios";
import carousel from "vue-owl-carousel";
import Countdown from "vuejs-countdown";
import moment from "moment-timezone";
import RegOptions from "@/components/RegOptions.vue";
import PublicFooter from "@/components/PublicFooter.vue";
import SessionDetails from "@/components/SessionDetails.vue";
import router from "@/router";
import common from "@/common";

var self;
export default {
  name: "Home",
  components: {
    carousel,
    Countdown,
    RegOptions,
    PublicFooter,
    SessionDetails,
  },
  metaInfo() {
    return {
      title: "World Youth Skills Day (APAC) 2022",
      meta: [
        { property: "og:type", content: "website" },
        {
          name: "description",
          content:
            "WYSD (Asia-Pacific) 2022 initiative will bring out the voice of youths so that various stakeholders in TVET can better understand the attitudes of youths when it comes to skills needed for the future.",
        },
        {
          name: "keywords",
          content:
            "WYSD 2022, WYSD ASIA-PACIFIC 2022, YOUth Matters: Celebrating Skills for the Future, Temasek Polytechnic, UNESCO, Skills future, National youth council, Skills future SG",
        },
        {
          property: "og:title",
          content:
            "WYSD APAC 2022 YOUth Matters: Celebrating Skills for the Future",
        },
        {
          property: "og:url",
          content: location.host,
        },
        { property: "og:type", content: "website" },
        {
          property: "og:description",
          content:
            "WYSD (Asia-Pacific) 2022 initiative will bring out the voice of youths so that various stakeholders in TVET can better understand the attitudes of youths when it comes to skills needed for the future.",
        },
        { property: "og:site_name", content: "WYSD 2022" },
        {
          property: "og:image",
          content:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FBranding%2F1200x628_1647965462226.png?alt=media&token=098e242f-7301-428b-80da-9afc9cebe25e",
        },
        {
          property: "twitter:card",
          content:
            "WYSD APAC 2022 YOUth Matters: Celebrating Skills for the Future",
        },
        {
          property: "twitter:title",
          content:
            "WYSD APAC 2022 YOUth Matters: Celebrating Skills for the Future",
        },
        {
          property: "twitter:description",
          content:
            "WYSD (Asia-Pacific) 2022 initiative will bring out the voice of youths so that various stakeholders in TVET can better understand the attitudes of youths when it comes to skills needed for the future.",
        },
        {
          property: "twitter:url",
          content: location.host,
        },
        {
          property: "twitter:description",
          content:
            "WYSD (Asia-Pacific) 2022 initiative will bring out the voice of youths so that various stakeholders in TVET can better understand the attitudes of youths when it comes to skills needed for the future.",
        },
        {
          property: "twitter:image",
          content:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FBranding%2F1200x628_1647965462226.png?alt=media&token=098e242f-7301-428b-80da-9afc9cebe25e",
        },
      ],
    };
  },
  data() {
    return {
      selectedEventTab: 0,
      hasE1665657022153: false,
      sessionDetailsPopup: false,
      sessionDetailsKey: 0,
      currentSession: null,
      BannerVideo: false,
      tab: null,
      videoUrl: null,
      sessionVideoUrl: null,
      items: ["Appetizers", "Entrees", "Deserts", "Cocktails"],
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      publicEventCollection: "",
      event_collectionName: "",
      RegPageOptions: false,
      count: 0,
      groupReg: false,
      key: 0,
      eventsLoaded: false,
      eventList: [],
      currentDomain: "",
      clientId: "",
      defaultEventId: "",
      selectedEventId: "",
      tabOrientation: 0,
      tab_hash_tag: 1,
      date_group: 0,
      external_session_details_popup: 1,
      donot_show_details_popup: 0,
      join_inperson_session_anytime: 1,
      allow_guest_join_inperson_session: 1,
      session_date_format: 0,
      hide_speaker_enabled: 1,
      isPublicPage: true,
      // terms_url: "",
      // privacy_url: "",
      eventDetail: null,
      environment: this.Environment(),
      loginDecision: false,
      selectedSessionId: "",
      stageUrl: "/livestageng",
      YouthEvent: [
        {
          videoId: 1,
          ThumbImg:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FVideos%2Fthumb1.jpg?alt=media",
          VideoFile:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FVideos%2F1.WYSD-Homepage%20Video.mp4?alt=media",
        },
        {
          videoId: 2,
          ThumbImg:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FVideos%2Fthumb2.jpg?alt=media",
          VideoFile:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FVideos%2F2.WYSD-Homepage%20Video.mp4?alt=media",
        },
        {
          videoId: 3,
          ThumbImg:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FVideos%2Fthumb3.jpg?alt=media",
          VideoFile:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FVideos%2F3.WYSD-Homepage%20Video.mp4?alt=media",
        },
        {
          videoId: 4,
          ThumbImg:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FVideos%2Fthumb4.jpg?alt=media",
          VideoFile:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FVideos%2F4.WYSD-HomepageVideo.mp4?alt=media",
        },
        {
          videoId: 5,
          ThumbImg:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FVideos%2Fthumb5.jpg?alt=media",
          VideoFile:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FVideos%2F5.WYSD-HomepageVideo.mp4?alt=media",
        },
      ],
      SessionVideo: [
        {
          sessionVideoId: 1,
          SessionVideoThumb:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2Fv1.jpg?alt=media",
          SessionVideoFile:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2Fvideo1.mp4?alt=media",
        },
        {
          sessionVideoId: 2,
          SessionVideoThumb:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2Fv2.jpg?alt=media",
          SessionVideoFile:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2Fvideo2.mp4?alt=media",
        },
        {
          sessionVideoId: 3,
          SessionVideoThumb:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2Fv3.jpg?alt=media",
          SessionVideoFile:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FTP%20WYSD%20Video%203%20FINAL%20Draft%205B.mp4?alt=media",
        },
      ],
      hearYouth: false,
      SessionVideoDialog: false,
      showCountdown: false,
      bannerVideoUrl: "",
      sessionsLoading: true,
      localTimeZone: "",
    };
  },
  computed: {
    CounterEventStartDate: function () {
      return moment(self.eventDetail.EventInfo.EventStartDate).isBefore()
        ? null
        : moment(self.eventDetail.EventInfo.EventStartDate).format(
            "YYYY-MM-DD HH:mm:ss" //"MMMM DD, YYYY"
          );
    },
  },
  created() {
    self = this;
    self.localTimeZone = common.getTimeZoneName();
    //alert("Home - Created")
    self.currentDomain = location.origin;
    bus.$on("CheckBrandingForPublicPage", () => {
      //alert("Home - Created-CheckBrandingForPublicPage 1");
      if (!self.publicEventCollection) {
        //alert("Home - Created-CheckBrandingForPublicPage 2");
        self.InitialLoad();
      }
    });
    self.InitialLoad();
  },
  mounted() {
    var data = {
      showUserWelcomeLoader: false,
    };

    bus.$emit("setUserWelcomeLoader", data);
    document.title = "Home";
    $(document).ready(function () {
      window.addEventListener("message", (event) => {
        // let iframe = document.querySelector("#divPublicSessions");
        // iframe.height = event.data.height;
        //alert(typeof event.data);
        if (typeof event.data == "object") {
          if (event.data.SessionId) {
            //alert("o: " + event.origin);
            if (event.data.action == "details") {
              //alert("message: " + event.data.action)
              self.sessionDetailsKey++;
              self.sessionDetailsPopup = true;
              self.currentSession = event.data.session;
              //alert("SD:"+self.currentSession.SessionId);
            } else {
              self.goToSession(event.data);
            }
          } else if (event.data.action == "tabchange") {
            self.resizeSessionFrame();
          }
        }
      });
    });
  },
  updated() {
    setTimeout(() => {
      self.resizeSessionFrame();
    }, 1000);
    setTimeout(() => {
      self.resizeSessionFrame();
    }, 2000);
  },
  methods: {
    openNewPdf() {
      // window.open(
      //   //"https://drive.google.com/file/d/13xoxFwj-kyP2FxAT4HGRVVLsPXW7dYeb/view?usp=sharing",
      //   "firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FResources%2FWYSD%20(APAC)%20Youth%20Declaration%202022_FINAL.pdf?alt=media",
      //   "_blank"
      // );
      self.downloadResourceFile("https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FResources%2FWYSD%20(APAC)%20Youth%20Declaration%202022_FINAL.pdf?alt=media&token=a40e511a-f539-4948-9e7c-d4e3e0f59ad7");
    },
    downloadResourceFile(url) {
      //this.showLoader();
      axios({
        method: "get",
        url: url,
        responseType: "arraybuffer",
      })
        .then((response) => {
          self.forceFileDownload(response);
        })
        .catch(() => console.log("error occured"));
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "YOUTH_DECLARATION.pdf"); //or any other extension
      document.body.appendChild(link);
      link.click();
      //this.hideLoader();
    },
    InitialLoad() {
      //alert("InitialLoad");
      self.clientId = self.getClientId();
      self.publicEventCollection = self.getPublicEventCollection();
      self.event_collectionName = self.getEventCollectionName();
      self.LoadEvents();
    },
    SessionsLoaded() {
      //alert("SessionsLoaded");
      self.sessionsLoading = false;
    },
    goToSession(session) {
      if (session) {
        var user = self.getSessionUserProfile();
        if (
          (user && user.UserId) ||
          (session.SessionTypeDetails.TypeID == 5 &&
            self.allow_guest_join_inperson_session == 1)
        ) {
          //alert("user found: " + user.UserId);
          // alert("Session Id: " + event.data.SessionId);
          // alert("Session Name: " + event.data.Name);
          if (
            self.event_collectionName &&
            self.event_collectionName == self.publicEventCollection
          ) {
            self.startSession(session);
            //router.push("/livestageng/" + event.data.SessionId);
          } else {
            //alert("Select Event");
            var eventFound = false;
            var mappedEvents = self.GetMappedEvents();
            for (var i = 0; i < mappedEvents.length; i++) {
              if (
                self.publicEventCollection ==
                mappedEvents[i].EventCollectionName
              ) {
                //self.CurrentAdminEvent = mappedEvents[i];
                self.ChangeCurrentEvent(
                  mappedEvents[i].ClientId,
                  mappedEvents[i].EventId,
                  false,
                  true
                );
                setTimeout(() => {
                  self.startSession(session);
                  //router.push("/livestageng/" + event.data.SessionId);
                }, 1000);
                eventFound = true;
                break;
              }
            }
            if (
              session.SessionTypeDetails.TypeID == 5 &&
              self.allow_guest_join_inperson_session == 1
            ) {
              self.startSession(session);
            } else if (!eventFound) {
              self.goToRegister(session.SessionId);
            }
          }
        } else {
          self.selectedSessionId = session.SessionId;
          if (
            session.session &&
            session.session.PublicJoinURLs &&
            session.session.PublicJoinURLs.Attendee
          ) {
            self.stageUrl = session.session.PublicJoinURLs.Attendee;
          }
          self.loginDecision = true;
        }
      }
    },
    startSession(session) {
      self.AddEventAnalytics({
        pageName: "/home",
        action: "click",
        actionType: "",
        actionLabel: "joinSession",
      });
      if (session && session.SessionId && session.SessionTypeDetails) {
        if ([1, 2, 3, 4].includes(session.SessionTypeDetails.TypeID)) {
          let userType = self.getSessionAttendeeType(session.session);
          if (
            userType == 1 &&
            session.session.PublicJoinURLs &&
            session.session.PublicJoinURLs.Host
          ) {
            router.push(
              session.session.PublicJoinURLs.Host + "/" + session.SessionId
            );
          } else if (
            userType == 2 &&
            session.session.PublicJoinURLs &&
            session.session.PublicJoinURLs.Host
          ) {
            router.push(
              session.session.PublicJoinURLs.Speaker + "/" + session.SessionId
            );
          } else if (
            userType == 4 &&
            session.session.PublicJoinURLs &&
            session.session.PublicJoinURLs.Host
          ) {
            router.push(
              session.session.PublicJoinURLs.Attendee + "/" + session.SessionId
            );
          } else {
            router.push("/livestageng/" + session.SessionId);
          }
        } else if (session.SessionTypeDetails.InPersonURL) {
          if (session.SessionTypeDetails.InPersonURL.startsWith("/")) {
            router.push(session.SessionTypeDetails.InPersonURL);
          } else {
            window.open(session.SessionTypeDetails.InPersonURL, "_blank");
            //self.postLeaderboardAction("SNVW");
          }
        }
      }
    },
    getSessionAttendeeType(session) {
      let userType;
      var user = self.getSessionUserProfile();
      if (user && user.UserId) {
        session.MappedHosts.forEach(function (item) {
          if (item.AttendeeId == user.UserId) {
            userType = 1;
          }
        });
        if (!userType) {
          if (session.MappedCoHost) {
            if (session.MappedCoHost.AttendeeId == user.UserId) {
              userType = 1;
            }
          }
        }
        if (!userType) {
          session.MappedSpeakers.forEach(function (item) {
            if (item.AttendeeId == user.UserId) {
              userType = 2;
            }
          });
        }
      }
      return userType ? userType : 4;
    },
    OpenBannerVideo() {
      self.BannerVideo = true;
      self.bannerVideoUrl =
        "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FResources%2FWorld%20Youth%20Skills%20Day%20(Asia-Pacific)%202022%20Closing%20Video.mp4?alt=media";
    },
    closeBannerVideo() {
      self.bannerVideoUrl = null;
      self.BannerVideo = false;
    },
    OpenYouthVideo(data) {
      console.log("data-", data);
      self.videoUrl = data.VideoFile;
      self.hearYouth = true;
    },
    closeDialog() {
      self.videoUrl = null;
      self.hearYouth = false;
    },
    openSessionVideo(data) {
      console.log("data-", data);
      self.sessionVideoUrl = data.SessionVideoFile;
      self.SessionVideoDialog = true;
    },
    closeSessionVideoDialog() {
      self.SessionVideoDialog = false;
      self.sessionVideoUrl = null;
    },
    resizeSessionFrame() {
      if (document.getElementById("divPublicSessions")) {
        // document.getElementById("divPublicSessions").style.height =
        //   document.getElementById("divPublicSessions").contentWindow.document
        //     .documentElement.scrollHeight + "px";
        document.getElementById("divPublicSessions").style.height =
          document
            .getElementById("divPublicSessions")
            .contentWindow.document.body.getElementsByClassName(
              "session-list-container"
            )[0].scrollHeight +
          70 +
          "px";
      }
    },
    goToLogin(sessionId) {
      //alert("Go To Login");
      //self.showSnackbar("Please", "info", "top");
      let eventId = self.getPublicEventId();
      if (eventId) {
        let redirect_url = self.stageUrl + "/" + sessionId;
        router.push("/?event_id=" + eventId + "&redirect_url=" + redirect_url);
      }
    },
    goToRegister(sessionId) {
      //alert("Go To Register");
      bus.$emit("toggleLoader", true);
      //self.clickOpenOption();
      let eventId = self.getPublicEventId();
      if (self.clientId && eventId) {
        let redirect_url = self.stageUrl + "/" + sessionId;
        self.getCheckoutFormJson(
          self.clientId,
          eventId,
          1,
          true,
          redirect_url,
          true
        );
      }
    },
    clickOpenOption() {
      if (self.publicEventCollection) {
        this.key++;
        this.RegPageOptions = true;
      }
    },
    LoadEventDetails() {
      // alert("self.clientId: "+self.clientId);
      // alert("self.defaultEventId: "+self.defaultEventId);
      axios
        .get(
          APIs.EventBrandingJsonData +
            "?iid=OA_UAT" +
            "&cid=" +
            self.clientId +
            "&eid=" +
            self.defaultEventId
        )
        .then((res) => {
          self.eventDetail = res.data.result;
          setTimeout(() => {
            self.showCountdown = true;
          }, 1000);
        });
    },
    LoadSessions(eventId) {
      //alert(eventId);
      if (eventId && self.selectedEventId != eventId) {
        self.sessionsLoading = true;
        //$("#divPublicSessions").html("");
        self.selectedEventId = eventId;
        if (self.eventList[0].EventId == eventId) {
          self.tab_hash_tag = 1;
          self.date_group = 0;
          self.session_date_format = 0;
          self.tabOrientation = 0;
          self.donot_show_details_popup = 0;
          self.join_inperson_session_anytime = 1;
          self.allow_guest_join_inperson_session = 1;
        } else {
          self.tab_hash_tag = 0;
          self.date_group = 0;
          self.session_date_format = 1;
          self.tabOrientation = 1;
          self.donot_show_details_popup = 1;
          self.join_inperson_session_anytime = 1;
          self.allow_guest_join_inperson_session = 1;
        }
      }
    },
    LoadEvents() {
      if (self.clientId) {
        db.collection("OA_UAT/ClientList/Clients")
          .doc(self.clientId)
          .collection("Events")
          //.where("IsPublished", "==", true)
          .where("EventTypeId", "==", 2)
          .where("AllowRegistration", "==", true)
          .get()
          .then((querySnapshot) => {
            self.eventList = [];
            querySnapshot.forEach((doc) => {
              var data = doc.data();
              // if (
              //   !location.host.toLowerCase().includes("localhost") ||
              //   data.EventId == "E1657723356590"||
              //   data.EventId == "E1647445200290"||
              //   data.EventId == "E1647459328886"
              // ) {
              if (
                !data.IsTemplate &&
                !["E1597239344083", "E1599630596349"].includes(doc.id)
              ) {
                var objEvent = new Object();
                if (doc.id == "E1665657022153") {
                  self.hasE1665657022153 = true;
                }
                objEvent.EventId = doc.id;
                objEvent.ClientId = data.ClientId;
                objEvent.Name = data.EventFullName;
                objEvent.IsPublished = data.IsPublished;
                objEvent.EventLogo = data.EventLogo;
                objEvent.EventStartDate = data.EventStartDate;
                objEvent.EventEndDate = data.EventEndDate;
                objEvent.EventCollectionName = data.EventCollectionName;
                objEvent.EventTypeId = data.EventTypeId;
                objEvent.LocalTimeZone = moment.tz.guess();
                objEvent.TimeXone = data.TimeZone;
                objEvent.EventStartTimestamp = data.EventStartDate.seconds;
                objEvent.EventEndTimestamp = data.EventEndDate.seconds;
                var dateFormat = require("dateformat");
                objEvent.EventStartDateString = dateFormat(
                  data.EventStartDate.seconds,
                  "mmm dd, yyyy"
                );
                objEvent.EventEndDateString = dateFormat(
                  data.EventEndDate.seconds,
                  "mmm dd, yyyy"
                );
                objEvent.EventDateStringLabel = objEvent.EventStartDateString;
                if (
                  objEvent.EventStartDateString != objEvent.EventEndDateString
                ) {
                  objEvent.EventDateStringLabel +=
                    " to " + objEvent.EventEndDateString;
                }
                //if(self.eventList.length<3){
                self.eventList.push(objEvent);
                //}
              }
              // }
            });
            if (self.eventList.length > 0) {
              if (self.hasE1665657022153) {
                self.selectedEventId = "E1665657022153";
                self.selectedEventTab = self.eventList.length - 1;
              } else {
                self.selectedEventId = self.eventList[0].EventId; //"E1647445200290";//
              }
              self.defaultEventId = self.eventList[0].EventId;
              self.LoadEventDetails();
            }
            self.eventsLoaded = true;
          })
          .catch((error) => {
            console.log("Error getting events: ", error);
          });
      } else {
        setTimeout(() => {
          self.LoadEvents();
        }, 5000);
      }
    },
  },
};
</script>
